// extracted by mini-css-extract-plugin
export var askAiIcon = "_k4-9";
export var container = "_k4-0";
export var groupSeparator = "_k4-a";
export var highlight = "_k4-4";
export var resultIcon = "_k4-5";
export var resultItem = "_k4-7";
export var resultSubtitle = "_k4-3";
export var resultTitle = "_k4-2";
export var resultsList = "_k4-1";
export var searchGroup = "_k4-6";
export var selected = "_k4-8";